
import { z } from "zod";

export const EscalationRiskTierValues = ["CRITICAL", "AT_RISK", "WATCH", "HEALTHY"] as const;
export const EscalationRiskTierSchema = /* @__PURE__ */ z.enum(EscalationRiskTierValues);
export const EscalationRiskTier: (typeof EscalationRiskTierSchema)["enum"] = { "CRITICAL": "CRITICAL", "AT_RISK": "AT_RISK", "WATCH": "WATCH", "HEALTHY": "HEALTHY" };
export type EscalationRiskTier = (typeof EscalationRiskTierValues)[number];
